import { createContext, useContext } from 'react';
export var LanguageContext = createContext(undefined);
export var useLanguage = function () {
    var context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};
